<input type="file" #fileDropRef id="fileDropRef" [multiple]="options.allowMultipleFiles" [accept]="getAccpetedFileTypes()" (change)="onFilePicked($event)" />
@if (loading) {
<div class="centered">
  <div><h2>Loading...</h2></div>
  <mat-spinner></mat-spinner>
</div>
} @if (!loading) {
<div class="container">
  <div class="right-centered"
    ><h2>{{ options.heading }}</h2
    ><button mat-icon-button class="clear" (click)="close(null)"><mat-icon>clear</mat-icon></button></div
  >
  <div>Please note, due to possible browser caching merchant names,</div>
  <div>terminal ID's and serial numbers might take up to 5 minutes to reflect.</div>
  @if (files.length < 1) {
  <div class="empty-files flex-align">
    @if (!showTemplate) {
    <div class="dropzone drop" [ngClass]="{ shake: dropError != '' }" appDragNDrop (fileDropped)="onFileDropped($event)">
      <div class="upload-icon-wrapper">
        <mat-icon class="upload-icon">file_upload_outlined</mat-icon>
      </div>
      @if (dropError == '') {
      <h3>{{ options.allowMultipleFiles ? 'Drag and drop file/s here' : 'Drag and drop file here' }}</h3>
      } @if (dropError != '') {
      <h3 class="error">{{ dropError }}</h3>
      }
    </div>
    } @if (showTemplate) {
    <img class="template-img" [src]="options.templateImageName" />
    } @if (options.templateImageName != null) {
    <div class="flex-row">
      <a class="template" (mouseenter)="toggleTemplate()" (mouseleave)="toggleTemplate()"
        >View Template <br />
        (Instructions)</a
      >
      <h3 class="or">or</h3>
    </div>
    } @if (options.templateImageName == null) {
    <h3>or</h3>
    }
    <button mat-raised-button color="browse" (click)="fileDropRef.click()">{{ options.allowMultipleFiles ? 'Browse for file/s' : 'Browse for file' }}</button>
  </div>
  } @if (files.length > 0) {
  <div>
    <div>
      <div class="multiple-file-wrapper">
        <h3>{{ options.allowMultipleFiles ? 'Files' : 'File' }}</h3>
        @if (options.allowMultipleFiles) {
        <div class="drop stretch" [ngClass]="{ shake: dropError != '' }" appDragNDrop (fileDropped)="onFileDropped($event)">
          <div>
            <mat-icon>file_upload_outlined</mat-icon>
            @if (dropError == '') {
            <h3>Drag and drop file/s here</h3>
            } @if (dropError != '') {
            <h3 class="error">{{ dropError }}</h3>
            }
          </div>
        </div>
        }
      </div>
      <mat-list [ngClass]="{ 'list': options.allowMultipleFiles, 'list-small': !options.allowMultipleFiles }">
        @for (file of files; track file; let i = $index) {
        <mat-list-item>
          <mat-icon mat-list-icon>insert_drive_file</mat-icon>
          <div mat-line>{{ file.name }}</div>
          <div mat-line>{{ formatBytes(file.size, 2) }}</div>
          <button mat-icon-button class="delete" (click)="deleteFile(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </mat-list-item>
        }
      </mat-list>
    </div>
  </div>
  }
  <div class="actions">
    @if (files.length > 0) {
    <button mat-raised-button color="browse" (click)="upload()">{{ options.submitButtonTitle ?? 'Upload' }}</button>
    } @if (files.length > 0 && options.allowMultipleFiles) {
    <button mat-raised-button color="browse" (click)="fileDropRef.click()">Browse for more Files</button>
    }
  </div>
</div>
}
